<div class="encontrar-doctor-container white-panel" id="encontrar-doctor" #rootElement>
    <div class="container">
        <h2>Encuentre a un Dr. Cercano y comience la transformación de su sonrisa</h2>
        <h5 class="text-center mt-3">Lista de Doctores</h5>
        <div class="row mt-3">
            <div class="col-12">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Teléfono</th>
                            <th>Ciudad</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let doctor of doctores">
                            <td>{{doctor.user.name}}</td>
                            <td>{{doctor.telefono}}</td>
                            <td>{{doctor.ciudad}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>